import React from 'react';

import { StateLanguage } from '../../../../languages/config/StateLanguage';
import { Product } from '../../../../models/product.model';
import { Service } from '../../../../models/service.model';
import { languageValue } from '../../../../libraries/language.library';

export interface AppInventoryViewNamesProps {
  record: any | Service | Product
};

const AppInventoryViewNames: React.FunctionComponent<AppInventoryViewNamesProps> = ({record}) => {
  const {lang} = StateLanguage()

  return (
    <div className="card card-flush">
      <div className="card-header">
        <div className="card-title">
          <h5>{lang.labels.names}</h5>
        </div>
      </div>
      <div className="card-body pt-0">
        { Object.values(record.names).every((value: any) => (value.length > 0))
          ?
          <>
            { Object.entries(record.names).map (( (item: any, index: number) => { return (
              <div key={index} className={`${index < 3 && "pb-2"} ${item[1].length === 0 && "d-none"}`}>
                <div className="fw-bold">{item[1]}</div>
                <div className="fs-8 text-muted">{languageValue(lang, item[0].toUpperCase())}</div>
              </div>
            )}))}
          </>
          :
          <div className="text-secondary text-justify">
            {lang.labels.noRecordsFound}
          </div>
        }
      </div>
    </div>
  )
};

export default AppInventoryViewNames;
